import { z } from "zod"

const InstagramIntegration = z.object({
  id: z.bigint().transform(String),
  name: z.string(),
  username: z.string(),
  accountId: z.string(),
  profilePicture: z.string().nullish(),
  failedAt: z
    .date()
    .transform((value) => value.toISOString())
    .nullish(),
})

export const InstagramIntegrationsRespondeData = z.array(InstagramIntegration)
